import _remove from 'lodash/remove';
import addEmployeeTemplate from './../../settings/add-employee/add-employee.html';
import editEmployeeTemplate from './../../settings/edit-employee/edit-employee.html';
import template from './employees.html';

class EmployeesComponent {
  /** @ngInject */
  constructor(
    $log, $q, $mdDialog, $mdToast,
    SchoolCommonRoomService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$q = $q;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.EmployeeService = EmployeeService;

    this.columnKeys = ['fullNameWithAccount', 'roleName'];
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
      this.EmployeeService.getUnassignedEmployees(0, true).then(result => {
        this.unassignedEmployees = Object.assign([], result);
      })
        .catch(() => {
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Nie można pobrać danych z serwera')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.schoolCommonRoom) {
      this.schoolCommonRoom = {...this.schoolCommonRoom};
    }

    if (changes.employees) {
      this.employees = Object.assign([], this.employees);
    }

    if (changes.roles) {
      this.roles = Object.assign([], this.roles);
    }
  }

  add(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddEmployeeController',
      template: addEmployeeTemplate,
      clickOutsideToClose: true,
      locals: {
        unassignedEmployees: this.unassignedEmployees,
        roles: this.roles,
        schoolCommonRoom: this.schoolCommonRoom
      },
      targetEvent: ev
    })
      .then(employee => {
        employee.fullNameWithAccount = employee.fullName;
        this.employees.unshift(employee);
      }, () => {})
      .finally(() => {
        this.EmployeeService.getUnassignedEmployees(0, true).then(result => {
          this.unassignedEmployees = Object.assign([], result);
        });
      });
  }

  edit(id, ev) {
    const employee = {...this.employees.filter(item => item.id === id)[0]};
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditEmployeeController',
      template: editEmployeeTemplate,
      clickOutsideToClose: true,
      locals: {
        employee,
        roles: this.roles,
        schoolCommonRoom: this.schoolCommonRoom
      },
      targetEvent: ev
    })
      .then(() => {
        this.EmployeeService.getSchoolCommonRoomEmployees(this.schoolCommonRoom.id, true)
          .then(result => {
            this.employees = Object.assign([], result);
          });
      }, () => {})
      .finally(() => {
        this.EmployeeService.getUnassignedEmployees(0, true).then(result => {
          this.unassignedEmployees = Object.assign([], result);
        });
      });
  }

  remove(employeeId) {
    const employee = {...this.employees.filter(item => item.id === employeeId)[0]};
    this.EmployeeService.deleteEmployee(employee, this.schoolCommonRoom.id)
      .then(employee => {
        _remove(this.employees, item => item.id === employee.id);
        this.EmployeeService.getUnassignedEmployees(0, true).then(result => {
          this.unassignedEmployees = Object.assign([], result);
        });
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto nauczyciela ze świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const Employees = {
  bindings: {
    me: '<',
    schoolCommonRoom: '<',
    employees: '<',
    roles: '<'
  },
  template,
  controller: EmployeesComponent
};
